// extracted by mini-css-extract-plugin
export default {"upgradeLinkBtn":"upgradeLinkBtn_RixVx","max":"max_kLjNq","ultra":"ultra_qNMfL"};